<template>
	<div> 
		<h2>
			{{ product }} are in stock {{ stock_count }}
		</h2>
	</div>
</template>

<script>
    export default {
    	data() {
    		return {
    			product: 'boots',
    			stock_count: 16
    		}
    	},
        mounted() {
            console.log('Component mounted.')
        }
    }
</script>

<style>
.greeting {
  color: red;
  font-weight: bold;
}
</style>